import homepageFallback from "../../content/publicHome/homepageFallback";
import { HOMEPAGE_SINGLETON_ID } from "../../types/publicHomepage";
import { getSanityClient } from "./client";

export const HOMEPAGE_QUERY = `
  *[_type == "homepage" && _id == $id][0]{
    seoModule,
    heroModule,
    proofStripModule,
    benefitCardsModule,
    processStoryModule,
    systemShowcaseModule,
    audienceSplitModule,
    missionModule,
    trustModule{
      ...,
      items[]->{
        title,
        text
      }
    },
    faqModule{
      ...,
      items[]->{
        question,
        answer
      }
    },
    ctaModule
  }
`;

function isObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function mergeDeep(baseValue, overrideValue) {
  if (Array.isArray(baseValue) && Array.isArray(overrideValue)) {
    return overrideValue.length ? overrideValue : baseValue;
  }

  if (isObject(baseValue) && isObject(overrideValue)) {
    const merged = { ...baseValue };
    Object.keys(overrideValue).forEach((key) => {
      merged[key] = mergeDeep(baseValue[key], overrideValue[key]);
    });
    return merged;
  }

  return overrideValue ?? baseValue;
}

export function normalizeHomepageContent(content) {
  return mergeDeep(homepageFallback, content || {});
}

export async function loadHomepageContent() {
  const client = getSanityClient();

  if (!client) {
    return {
      source: "fallback",
      data: homepageFallback,
    };
  }

  try {
    const content = await client.fetch(HOMEPAGE_QUERY, { id: HOMEPAGE_SINGLETON_ID });
    return {
      source: content ? "sanity" : "fallback",
      data: normalizeHomepageContent(content),
    };
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn("Homepage content fallback activated:", error);
    }

    return {
      source: "fallback",
      data: homepageFallback,
    };
  }
}
